var _defs, _rect, _rect2, _rect3, _path, _path2, _g, _g2, _g3, _g4, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarBackgroundCustom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 580,
    height: 2200,
    viewBox: "0 0 580 2200",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1A3062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#244789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#16284f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: "50%",
    cy: "22%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ee6ff",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#7ee6ff",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7ee6ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 26,
    height: 26,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0V26",
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.055,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softBlur",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vignette",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000000",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "18%",
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82%",
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("marker", {
    id: "routeArrow",
    markerWidth: 10,
    markerHeight: 10,
    refX: 8,
    refY: 5,
    orient: "auto",
    markerUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 Z",
    fill: "#a8f0ff",
    fillOpacity: 0.55
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 2200,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 2200,
    fill: "url(#glow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 2200,
    fill: "url(#grid)",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-120 420 C 110 210, 340 210, 720 40 L720 330 C 410 470, 220 520, -120 740 Z",
    fill: "#ffffff",
    opacity: 0.035
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-160 1460 C 160 1260, 360 1260, 760 1080 L760 1380 C 470 1520, 250 1570, -160 1790 Z",
    fill: "#7ee6ff",
    opacity: 0.03
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 170          C 190 250, 130 360, 210 440          C 310 545, 255 710, 290 840          C 325 965, 260 1090, 160 1260          C 105 1355, 170 1440, 250 1460          C 350 1485, 420 1510, 500 1480          C 560 1460, 520 1680, 360 1840          C 270 1930, 260 2050, 430 2120",
    stroke: "#7ee6ff",
    strokeOpacity: 0.75,
    strokeWidth: 2.4,
    strokeDasharray: "10 10",
    markerEnd: "url(#routeArrow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 310          C 430 380, 430 470, 450 560          C 475 670, 505 780, 520 900          C 540 1040, 520 1180, 460 1320          C 410 1440, 410 1600, 470 1700",
    stroke: "#a8f0ff",
    strokeOpacity: 0.55,
    strokeWidth: 2,
    strokeDasharray: "3 11",
    markerEnd: "url(#routeArrow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 720 C 160 660, 260 660, 350 720          C 430 770, 470 840, 480 920",
    stroke: "#e6fbff",
    strokeOpacity: 0.42,
    strokeWidth: 2,
    strokeDasharray: "14 8",
    markerEnd: "url(#routeArrow)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softBlur)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 360,
    r: 90,
    fill: "#7ee6ff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 820,
    r: 130,
    fill: "#7ee6ff",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 1320,
    r: 160,
    fill: "#7ee6ff",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 1880,
    r: 150,
    fill: "#7ee6ff",
    fillOpacity: 0.06
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16,
    stroke: "#ffffff",
    strokeOpacity: 0.55,
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 250,
    width: 72,
    height: 72,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428,
    y: 260,
    width: 72,
    height: 72,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 1120,
    width: 78,
    height: 78,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 1190,
    width: 78,
    height: 78,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 1710,
    width: 80,
    height: 80,
    rx: 18
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24,
    stroke: "#a8f0ff",
    strokeOpacity: 0.8,
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 308 h40 l10 -16 h18 l-12 16 h8 l-10 18 h-48 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 318 h60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 286 l26 10 -26 10 -8 22 -10 -4 6 -18 -20 -10 20 -10 -6 -18 10 -4 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 1138 h24 l10 10 v38 h-34 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 1138 v10 h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 1248 v-28 M450 1248 v-40 M470 1248 v-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 1248 h56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 1750,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 1750 h36 M290 1732 v36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 1736 c10 8 10 20 0 28 M301 1736 c-10 8 -10 20 0 28"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 2200,
    fill: "url(#vignette)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBackgroundCustom);
export default __webpack_public_path__ + "static/media/sidebar_background_custom.180425369d3ada5fb3f3a6a2e9ba8dcc.svg";
export { ForwardRef as ReactComponent };